import { IEvent } from "@Interfaces/redux/store/IEvent";
import { IHost } from "@Interfaces/redux/store/IHost";

export const getBookingQuestions = ({
    eventData,
    hostData,
    placement,
}: {
    hostData: IHost.IHostData;
    eventData: IEvent.IEventData;
    placement?: number;
}) => {
    let questionSource = hostData?.leads_q_and_a || [];
    questionSource = eventData?.q_and_a || [];

    return placement !== undefined
        ? questionSource.filter(item => {
              return item.question_placement === placement;
          })
        : questionSource;
};
